/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import tmplAWPackageAdditionalInformationView from './AWPackageAdditionalInformationView.hbs';

const AWPackageAdditionalInformationView = View.extend({
  template: tmplAWPackageAdditionalInformationView,

  onRender() {},

  toggleForm(state) {
    this.$el.find(':input').prop('disabled', !state);
  },

  async onSave() {
    if (!this.model.get('editable')) {
      return;
    }
  }
});

export default AWPackageAdditionalInformationView;
